import type { ProductCardSkeletonProps } from '@maestro/commerce-blocks/components/product-card/product-card.types'

import classNames from 'classnames'
import Skeleton from 'react-loading-skeleton'

const ProductCardSkeleton = (props: ProductCardSkeletonProps) => {
  const { isCompact = false } = props
  return (
    <div
      className={classNames('product-card', {
        'product-card--compact': isCompact,
      })}
    >
      <div className="product-card__image-wrapper">
        <div className="image-product" />
      </div>
      <div className="product-card__description">
        <div className="product-card__info">
          <span className="product-brand product-card__brand">
            <Skeleton width={50} />
          </span>
          <h2 className="product-card__title">
            <span className="product-card__title-link">
              <Skeleton width={80} />
            </span>
          </h2>
        </div>
        <div className="product-card__price">
          <Skeleton
            width={60}
            className="price"
            containerClassName="skeleton__wrapper--block"
          />
        </div>
        <div className="product-card__action"></div>
      </div>
    </div>
  )
}

export default ProductCardSkeleton
